import React from "react";

import { GatewayWithSourceViewStateTypes } from "@common/types/gateways-list-types";
import { SourcesListRowForGatewaysList } from "@src/components/molecules/sources-list-row-for-gateways-list/sources-list-row-for-gateways-list";

export interface SourcesListForGatewaysPropTypes {
  gatewayData: GatewayWithSourceViewStateTypes; // Replace 'any' with the actual type if available
}

export const SourcesListForGatewaysList = ({
  gatewayData,
}: SourcesListForGatewaysPropTypes) => {
  return (
    <tbody>
      {gatewayData.sources.map((sourceData, i) => (
        <SourcesListRowForGatewaysList
          key={i}
          gatewayData={gatewayData}
          sourceData={sourceData}
        />
      ))}
    </tbody>
  );
};
